<script lang="ts">
  import moment from "moment";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import type { Storefront } from "@shared/types/Storefront";

  export let storefront: Storefront;

  let storefrontTitle = storefront.title || storefront.distributor.name + " Storefront";

  function formatDate(d: any) {
    //@ts-ignore
    return d === null ? "" : moment(d).format("MMM D, YYYY hh:mm a");
  }

  function updatedBy() {
    return storefront.previously_updated_by === null
      ? ""
      : " by " +
          storefront.previously_updated_by.first_name +
          " " +
          storefront.previously_updated_by.last_name;
  }
  //@ts-ignore
  const sfpreviewPath = window.C.IMAGE_PATHS["storefront-preview.svg"];

  const switchAndEdit = storefront => {
    window.location.href = "distributor/storefronts/" + storefront.distributor_id;
  };
</script>

<div
  class="fizz-card-floating fizz-card-padded fizz-flex-row-responsive fizz-stack-32"
  id="switch-storefront-{storefront.id}"
>
  <img
    src={sfpreviewPath}
    alt="Storefront preview"
    height="120"
    class="fizz-hide-on-small h-[120px]"
  />
  <div class="fizz-flex-item">
    <p class="fizz-heading-4">{storefrontTitle}</p>
    <p>Last updated {formatDate(storefront.updated_at)} {updatedBy()} </p>
  </div>
  <button
    on:click={() => switchAndEdit(storefront)}
    class="fizz-button-primary fizz-button-icon fizz-button-small"
  >
    <Icon type="Edit" extraClassNames="fizz-icon-16 fizz-icon-inverse" height="16" width="16"
    ></Icon>
    <span>Edit Storefront</span>
  </button>
</div>
